import React from 'react';
import { Route } from 'react-router-dom';

import DadosAcessos from '../../Adm/DadosAcessos';
import DadosLogs from '../../Adm/DadosLogs';
import DadosRelatorios from '../../Adm/DadosRelatorios';
import FaqFicha from '../../Adm/FAQ/FaqFicha';
import FaqIndex from '../../Adm/FAQ/FaqIndex';
import FichaUsuario from '../../Adm/FichaUsuario';
import FornecedoresComunicacoesIndex from '../../Adm/Fornecedores/Fornecedores/FornecedoresComunicacoesIndex';
import FornecedoresFicha from '../../Adm/Fornecedores/Fornecedores/FornecedoresFicha';
import FornecedoresPRIndex from '../../Adm/Fornecedores/Fornecedores/FornecedoresPR';
import FornecedoresRepresentantesIndex from '../../Adm/Fornecedores/Fornecedores/FornecedoresRepresentantesIndex';
import HistoricoRT from '../../Adm/Fornecedores/Fornecedores/HistoricoRT';
import ListaFornecedores from '../../Adm/ListaFornecedor';
import ListaUsuarios from '../../Adm/ListaUsuarios';

const AdmRoutes = () => {
  return (
    <>
      <Route path="adm/usuarios" element={<ListaUsuarios />} />

      <Route path="adm/acessos" element={<DadosAcessos />} />
      <Route path="adm/logs" element={<DadosLogs />} />
      <Route path="adm/relatorios" element={<DadosRelatorios />} />
      <Route path="adm/historicodert" element={<HistoricoRT />} />

      {/* Dados do Usuário */}
      <Route
        path="adm/usuarios/ficha/:id/dadosgerais"
        element={<FichaUsuario />}
      />

      {/* Dados do fornecedores */}
      <Route path="adm/fornecedores" element={<ListaFornecedores />} />
      <Route
        path="adm/fornecedores/ficha/:id/dadosgerais"
        element={<FornecedoresFicha />}
      />
      <Route
        path="adm/fornecedores/ficha/dadosgerais"
        element={<FornecedoresFicha />}
      />
      <Route
        path="adm/fornecedores/ficha/:id/representantes"
        element={<FornecedoresRepresentantesIndex />}
      />
      <Route
        path="adm/fornecedores/ficha/:id/pr"
        element={<FornecedoresPRIndex />}
      />
      <Route
        path="adm/fornecedores/ficha/:id/historico"
        element={<HistoricoRT />}
      />
      <Route
        path="adm/fornecedores/ficha/:id/comunicacoes"
        element={<FornecedoresComunicacoesIndex />}
      />

      <Route path="adm/fornecedores/faq" element={<FaqIndex />} />
      <Route
        path="adm/fornecedores/faq/ficha/dadosgerais"
        element={<FaqFicha />}
      />
      <Route
        path="adm/fornecedores/faq/ficha/:id/dadosgerais"
        element={<FaqFicha />}
      />
    </>
  );
};

export default AdmRoutes;
